import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { ErrorCodes } from 'liveReportService'
import { ErrorCodeToTranslationKey } from '../../utils'

interface ErrorDialogProps {
  open?: boolean
  onClose: () => void
  errorCode: ErrorCodes
  okButtonText?: string
}

const ErrorDialog = ({ open, onClose, errorCode, okButtonText }: ErrorDialogProps) => {
  const displayTheme = useDisplayTheme()
  const { t } = useTranslation()
  return (
    <Dialog mode={displayTheme} open={open} onClose={onClose} width="600px">
      <Dialog.DialogTitle>{t(`${ErrorCodeToTranslationKey[errorCode]}.title`)}</Dialog.DialogTitle>
      <Dialog.DialogContent>
        {t(`${ErrorCodeToTranslationKey[errorCode]}.message`)}
      </Dialog.DialogContent>
      <Dialog.DialogActions
        okButtonProps={{
          children: okButtonText,
          onClick: onClose
        }}
        closeButtonProps={{ onClick: undefined }}
      />
    </Dialog>
  )
}

export default ErrorDialog
